<script setup>
import { ref } from 'vue'
import { useDisplay } from 'vuetify'

const { smAndDown } = useDisplay()
const tab = ref(0)
const disks = [
  {
    name: 'Disk 1/上巻 FM音源',
    tracks: [
	'ビドー軍のテーマ（闇神ダールの復活）',
	'効果音1',
	'一触即発',
	'三銃士哀歌',
	'謀略',
	'効果音2',
	'ハヤテのテーマ',
	'左京のテーマ',
	'プロット兄弟のテーマ',
	'リリアンのテーマ',
	'クークのテーマ',
	'ロマールのテーマ',
	'アレックのテーマ',
	'BURAIのテーマ',
	'コマンドのテーマ',
	'ライバル登場',
	'闘いのテーマ',
	'闘い済んで',
	'勇士集結',
	'町や村のテーマ',
	'決戦ビドー城',
	'城での戦い',
	'新たな希望',
	'戦士の休息',
	'ゲームオーバー',
    ]
  },
  {
    name: 'Disk 2/上巻 PSG音源',
    tracks: [
	'ビドー軍のテーマ（闇神ダールの復活）',
	'効果音1',
	'一触即発',
	'三銃士哀歌',
	'謀略',
	'効果音2',
	'ハヤテのテーマ',
	'左京のテーマ',
	'プロット兄弟のテーマ',
	'リリアンのテーマ',
	'クークのテーマ',
	'ロマールのテーマ',
	'アレックのテーマ',
	'BURAIのテーマ',
	'コマンドのテーマ',
	'ライバル登場',
	'闘いのテーマ',
	'闘い済んで',
	'勇士集結',
	'町や村のテーマ',
	'決戦ビドー城',
	'城での戦い',
	'新たな希望',
	'戦士の休息',
	'ゲームオーバー',
    ]
  },
  {
    name: 'Disk 3/完結編1',
    tracks: [
		'オープニング 1',
		'オープニング 2',
		'オープニング 3',
		'オープニング 4',
		'オープニング 5',
		'メニュー',
		'戦闘',
		'イベント戦闘',
		'ゲームオーバー',
		'アレック＆クークの章　BGM 1',
		'アレック＆クークの章　BGM 2',
		'アレック＆クークの章　BGM 3',
		'アレック＆クークの章　BGM 4',
		'アレック＆クークの章　BGM 5',
		'アレック＆クークの章　BGM 6',
		'アレック＆クークの章　BGM 7',
		'アレック＆クークの章　BGM 8',
		'アレック＆クークの章　BGM 9',
		'アレック＆クークの章　BGM 10',
		'アレック＆クークの章　BGM 11',
		'アレック＆クークの章　BGM 12',
		'アレック＆クークの章　BGM 13',
		'ゴンザ&マイマイの章　BGM 1',
		'ゴンザ&マイマイの章　BGM 2',
		'ゴンザ&マイマイの章　BGM 3',
		'ゴンザ&マイマイの章　BGM 4',
		'ゴンザ&マイマイの章　BGM 5',
		'ゴンザ&マイマイの章　BGM 6',
		'ゴンザ&マイマイの章　BGM 7',
		'ゴンザ&マイマイの章　BGM 8',
		'ゴンザ&マイマイの章　BGM 9',
		'ゴンザ&マイマイの章　BGM 10',
		'ゴンザ&マイマイの章　BGM 11',
		'ゴンザ&マイマイの章　BGM 12',
		'左京&ナインテールの章　BGM 1',
		'左京&ナインテールの章　BGM 2',
		'左京&ナインテールの章　BGM 3',
      // …37曲分
    ]
  },
  {
    name: 'Disk 4/完結編2',
    tracks: [
		'左京&ナインテールの章　BGM 4',
		'左京&ナインテールの章　BGM 5',
		'左京&ナインテールの章　BGM 6',
		'ハヤテ＆リリアンの章　BGM 1',
		'ハヤテ＆リリアンの章　BGM 2',
		'ハヤテ＆リリアンの章　BGM 3',
		'ハヤテ＆リリアンの章　BGM 4',
		'ハヤテ＆リリアンの章　BGM 5',
		'ハヤテ＆リリアンの章　BGM 6',
		'ハヤテ＆リリアンの章　BGM 7',
		'ハヤテ＆リリアンの章　BGM 8',
		'ロマール&バージルの章　BGM 1',
		'ロマール&バージルの章　BGM 2',
		'ロマール&バージルの章　BGM 3',
		'ロマール&バージルの章　BGM 4',
		'ロマール&バージルの章　BGM 5',
		'ロマール&バージルの章　BGM 6',
		'ロマール&バージルの章　BGM 7',
		'いにしえの章　BGM 1',
		'いにしえの章　BGM 2',
		'いにしえの章　BGM 3',
		'いにしえの章　BGM 4',
		'いにしえの章　BGM 5',
		'いにしえの章　BGM 6',
		'いにしえの章　BGM 7',
		'いにしえの章　BGM 8',
		'いにしえの章　BGM 9',
		'いにしえの章　BGM 10',
		'いにしえの章　BGM 11',
		'いにしえの章　BGM 12',
		'いにしえの章　BGM 13',
		'いにしえの章　BGM 14',
		'エンディング',
		'未使用曲',
      // …34曲分
    ]
  }
]
</script>

<template>
  <v-container>

    <v-divider class="mx-10" thickness="2" />
	
	<p class="text-h5 pa-5">特典ディスク 収録曲一覧</p>

	<v-divider class="mx-10 mb-6" thickness="2" />
    
<!-- ?? PC表示（Tabs） -->
    <div v-if="!smAndDown">
      <v-tabs v-model="tab" grow color="primary">
        <v-tab v-for="(disk, index) in disks" :key="index">
          {{ disk.name }}
        </v-tab>
      </v-tabs>

      <v-window v-model="tab">
        <v-window-item
          v-for="(disk, index) in disks"
          :key="index"
          :value="index"
        >
		<v-list density="compact">
		<v-list-item
			v-for="(track, i) in disk.tracks"
			:key="i">
		<v-list-item-title class="text-body-1">
		{{ i + 1 }}.<span class="selectable"> {{ track }}</span>
		</v-list-item-title>
		</v-list-item>
		</v-list>
        </v-window-item>
      </v-window>
    </div>

    <!-- ?? スマホ表示（Accordion） -->
    <div v-else>
      <v-expansion-panels multiple>
        <v-expansion-panel
          v-for="(disk, index) in disks"
          :key="index"
        >
          <v-expansion-panel-title>
            {{ disk.name }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <v-list density="compact">
		<v-list-item class="text-body"
			v-for="(track, i) in disk.tracks"
			:key="i"
			:title="`${i + 1}. ${track}`"
		/>
            </v-list>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

  </v-container>
</template>
<style scoped>
.selectable {
  user-select: all;
}
</style>